/**
 * ObjectivesModal — set daily calorie / protein targets (or let AI decide).
 * No role=dialog by design.
 */
import { createPortal } from 'react-dom';

interface ObjectivesModalProps {
  objectiveCalories: string;
  objectiveProtein: string;
  onCaloriesChange: (value: string) => void;
  onProteinChange: (value: string) => void;
  onAIObjectives: () => void;
  onSaveObjectives: () => void;
  onClose: () => void;
}

export function ObjectivesModal({
  objectiveCalories,
  objectiveProtein,
  onCaloriesChange,
  onProteinChange,
  onAIObjectives,
  onSaveObjectives,
  onClose,
}: ObjectivesModalProps) {
  return createPortal(
    <div
      onClick={onClose}
      style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.35)', display: 'flex', alignItems: 'flex-start', justifyContent: 'center', paddingTop: '15vh', zIndex: 10000, fontFamily: "'DM Sans', sans-serif" }}
    >
      <div onClick={e => e.stopPropagation()} style={{ background: 'var(--color-surface)', borderRadius: 16, padding: 20, width: 380, maxWidth: '90vw', boxShadow: '0 8px 32px rgba(0,0,0,0.15)', display: 'flex', flexDirection: 'column', gap: 16 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <span style={{ fontSize: 16, fontWeight: 600, color: 'var(--color-text)' }}>Set Objectives</span>
          <button onClick={onClose} style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'var(--color-text-faint)', fontSize: 18, padding: '2px 4px' }}>&#x2715;</button>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          <div>
            <label style={{ fontSize: 12, fontWeight: 600, color: 'var(--color-text-faint)', textTransform: 'uppercase', letterSpacing: '0.04em' }}>Daily Calorie Target</label>
            <input
              type="number"
              value={objectiveCalories}
              onChange={e => onCaloriesChange(e.target.value)}
              placeholder="e.g. 1800"
              style={{ width: '100%', height: 40, padding: '0 12px', border: '1px solid #e5e7eb', borderRadius: 8, fontSize: 14, fontFamily: "'DM Sans', sans-serif", color: '#1f2937', marginTop: 4, boxSizing: 'border-box', outline: 'none' }}
            />
          </div>
          <div>
            <label style={{ fontSize: 12, fontWeight: 600, color: 'var(--color-text-faint)', textTransform: 'uppercase', letterSpacing: '0.04em' }}>Daily Protein Target (g)</label>
            <input
              type="number"
              value={objectiveProtein}
              onChange={e => onProteinChange(e.target.value)}
              placeholder="e.g. 120"
              style={{ width: '100%', height: 40, padding: '0 12px', border: '1px solid #e5e7eb', borderRadius: 8, fontSize: 14, fontFamily: "'DM Sans', sans-serif", color: '#1f2937', marginTop: 4, boxSizing: 'border-box', outline: 'none' }}
            />
          </div>
        </div>

        <div style={{ display: 'flex', gap: 8 }}>
          <button
            onClick={onAIObjectives}
            style={{ flex: 1, height: 40, borderRadius: 8, border: '1px solid #e5e7eb', background: 'var(--color-surface)', color: 'var(--color-text-faint)', fontSize: 13, fontWeight: 600, cursor: 'pointer', fontFamily: "'DM Sans', sans-serif" }}
          >
            Let AI decide
          </button>
          <button
            onClick={onSaveObjectives}
            disabled={!objectiveCalories && !objectiveProtein}
            style={{ flex: 1, height: 40, borderRadius: 8, border: 'none', background: (objectiveCalories || objectiveProtein) ? '#0ea5e9' : '#e5e7eb', color: (objectiveCalories || objectiveProtein) ? '#fff' : '#9ca3af', fontSize: 13, fontWeight: 600, cursor: (objectiveCalories || objectiveProtein) ? 'pointer' : 'default', fontFamily: "'DM Sans', sans-serif" }}
          >
            Save
          </button>
        </div>
      </div>
    </div>,
    document.body,
  );
}
